import type { GetRedditPostsParams } from '../types';

type RedditPostsRequestParams = Omit<GetRedditPostsParams, 'offset'>;

export default () => ({
  keywords: () => ['reddit', 'keywords'] as const,
  posts: (params: RedditPostsRequestParams) => ['reddit', 'posts', params] as const,
});
